<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 m-2">
				<div class="">
					<div v-if="loading" class="">
						Loading...
					</div>
					<div v-else-if="!Object.keys(order).length" class="">
						Nothing to Process!
					</div>
					<div v-else>
						<div class="">
							<div class="flex items-center justify-between pb-4 mb-4 border-b-2">
								<div>
									<h2 class="text-gray-700 text-xl sm:text-3xl">{{ forecast.job_name }}</h2>
								</div>
							</div>	
							<div class="flex text-sm px-2 py-1 bg-gray-600 text-gray-200 mt-6 text-center">
								<div class="flex-1 text-left">
									Product
								</div>
								<div class="w-48">
									Supplier
								</div>
								<div class="w-32">
									Order from
								</div>
								<div class="w-32">
									Qty
								</div>
								<div class="w-32">
									Price
								</div>
								<div class="w-32 text-right">
									Total
								</div>
							</div>
							
							<div class="">
								<template v-for="(products, cat) in order">
									<h3 class="text-sm">{{ categories[cat] }}</h3>
									<div class="p-2 border-b font-bold text-sm relative text-center" :class="{'bg-red-200 text-red-800': errors[index], 'bg-yellow-100 text-yellow-800': !errors[index] && orderDoesNotEquateForecastedQauntity[cat] && orderDoesNotEquateForecastedQauntity[cat].includes(index)}" v-for="(product, index) in products">
										<div class="flex flex-wrap" v-for="(split, splitKey) in product.order">
											<div class="absolute left-0 cursor-pointer" @click="splitProduct(cat, index)" v-if="(splitKey == product.order.length-1 && split.qty > 1) && product.status=='ordered' && product.category_id!=3">
												<svg class="w-4 h-4 text-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><path d="M29 175c2-.14 4-.4 5.94-.4H149.95c19-65.67 61.77-101.3 130.4-106.61V29l91.31 66.15-91.19 66.08v-39.55c-26.94.61-48.38 11.17-63.71 32.36-19.57 27.07-21.32 56.16-5.47 85.59 13.67 25.37 43.81 42.61 68.8 40.19v-39.31l91.57 66.33-91.3 66.16v-39c-68.61-5.3-111.51-40.83-130.38-106.59H34.94c-2 0-4-.26-5.94-.4V175z"/></svg>
											</div>
											<div class="flex-1 text-black text-left">
												<div class="ml-4 group">
													{{ product.name }}
													<span class="text-xs text-gray-600">{{ product.max }} </span>
													<span class="text-xs text-gray-600" v-if="product.pack_size > 1">Pack size : {{ product.pack_size }}</span>
													<div class="hidden rounded-full items-center justify-center text-sm bg-white w-4 h-4 group-hover:inline-flex cursor-pointer hover:bg-blue-200" @click="showInfo(index)">?</div>
												</div>
											</div>
											<div class="w-48">
												<div class="flex items-center">
													<select :disabled="split.disabled" v-model="split.supplier_id" name="supplier" class="form-select mt-1 block ml-1 w-full" v-if="product.status=='ordered'" :ref="`supplier-${cat}-${index}-${splitKey}`" @change="changeSupplierPrice(cat, index, splitKey)">
														<!-- <template v-for="supplier in suppliers"> -->
														<template v-if="product.warehouse_product_count > 0 && splitKey==0">
															<option :value="product.warehouse_id">{{ product.warehouse_name }} ({{ product.warehouse_product_count }})</option>
														</template>
														<template v-for="(supplier, index) in suppliers">
															<option :value="supplier.id" :key="supplier.id">{{ supplier.name }}</option>
														</template>
													</select>
													<x-icon title="Delete" class="rounded text-red-500 w-4 h-4 mx-1 cursor-pointer hover:bg-white" @click="removeSupplier(cat, index, splitKey)" v-if="split.supplier_id"></x-icon>						
												</div>
											</div>
											<div class="w-32">
												<select v-model="split.company_id" name="company" class="form-select mt-1 block mx-auto" v-if="product.status=='ordered'">
													<template v-for="company in companies">
														<option :value="company.id" :key="company.id">{{ company.name }}</option>
													</template>
												</select>
											</div>
											<div class="w-32 mt-1">
												<input class="w-28" type="text" placeholder="qty" v-model="split.qty" v-if="product.status=='ordered'" @input="checkQty(cat, index, product, split)">
												<!-- <p class="mt-1" v-if="product.pack_size > 1" :title="split.pack_rem > 0 ? split.pack_rem+' rem' : ''">{{ split.pack_qty }} pack<template v-if="split.pack_qty>1">s</template></p> -->
											</div>
											<div class="w-32 mt-1">
												<input class="w-28 disabled:opacity-75" type="text" placeholder="price" v-model="split.price" @input="checkPrice(index,$event)" v-if="product.status=='ordered'" :disabled="split.disabled == true">
												<div class="w-full">
													<span class="inline-block ml-1 font-light text-xs text-gray-500" v-if="split.price_date && split.status=='ordered'">{{ daysFrom(split.price_date) }}</span>
													<span class="inline-block ml-1 font-light text-xs text-blue-500 cursor-pointer" v-if="split.status=='ordered'" @click="showUpdatePricing = product">update</span>												
												</div>
											</div>
											<div class="w-32 mt-1 text-right">
												<span v-if="product.status=='ordered'">{{ calculatePrice(split.qty,split.price)  | toCurrency }}</span>
											</div>		
										</div>
										<div class="text-black mt-2 font-light text-left bg-gray-500 bg-opacity-10 divide-y divide-white" v-if="visibleInfo.find(pid => pid == index)">
											<div class="flex items-center p-1" v-for="(forecast, id) in productForecasts[cat][index]">
												<div class="flex-1 text-right font-bold">
													{{ forecast.name }}
												</div>
												<div class="w-32 flex items-center">
													<div class="px-3">
														<input :ref="`forecast_qty_${forecast.related_type}-${forecast.related_type_id}`" class="text-sm px-2 pr-2 py-1 bg-white rounded-sm w-14" type="text" :value="forecast.qty">
													</div>
													<div class="flex items-center justify-end space-x-2">
														<action-button class="flex justify-center text-green-600 bg-white p-1 rounded shadow hover:bg-green-100" @button-clicked="updateForecast(forecast)">
															<save-icon class="w-4 h-4"></save-icon>
														</action-button>
													</div>
												</div>
												<div class="text-center w-32">
													<div class="p-1 flex items-center space-x-2">
														<input type="checkbox" :name="`priority[${cat}${index}]`" :id="`priority${forecast.id}`" :value="forecast.related_type_id" v-model="order[cat][index]['priorities']">
														<label :for="`priority${forecast.id}`">prioritise</label>
													</div>
												</div>
												<div class="flex justify-end w-32">
													<action-button class="flex justify-center text-red-600 bg-white p-1 rounded shadow hover:bg-red-100" @button-clicked="deleteForecast(forecast)">
															<trash-icon class="w-4 h-4"></trash-icon>
														</action-button>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>

							<div class="bg-gray-200 mt-4 p-3 py-4">	
								<div class="flex items-center">
									<div class="flex items-center cursor-pointer" @click="showTransport=!showTransport">
										<chevron-component class="mr-1" :show="showTransport"></chevron-component>
										<h3>Transport Costs</h3>
									</div>
								</div>
								<div class="px-6" v-show="showTransport">														
									<div class="flex text-sm px-2 py-1 bg-gray-600 text-gray-200 mt-6 text-center">
										<div class="flex-1 text-left">
											Supplier
										</div>
										<div class="w-32 text-right">
											Add Transport Cost
										</div>
									</div>
									<template v-for="supplier_id in uniqueSuppliersInOrder">
										<div class="flex text-sm px-2 py-1 mt-6 text-center">
												<div class="flex-1 text-left">
													{{ getSupplierById(supplier_id).name }}
												</div>
												<div class="text-right">
													<input type="text" class="text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" @input="setTransportCost(supplier_id,$event)">
												</div>											
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
		</div>
		<div class="mt-4 bg-green-400 py-4" :class="hasError ? 'bg-green-400 cursor-not-allowed' : 'bg-green-600'" v-if="Object.keys(order).length">
			<action-button class="flex w-full justify-center text-white" @button-clicked="updateOrder" :disabled="hasError!==0">
				<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
				<span>Save</span>
			</action-button>
		</div>
		<portal to="modals" v-if="showUpdatePricing" :order="1">
			<update-product-pricing-modal
				:show="showUpdatePricing"
				:initial-product="showUpdatePricing"
				@close="showUpdatePricing = null"
				@reload="initData"
				>
			</update-product-pricing-modal>
		</portal>
		<portal to="modals" v-if="showDelete" :order="2">
			<confirm-delete
				:show="showDelete"
				:delete-object="showDelete"
				@close="showDelete = null"
				@delete="deleteObject"
			>
			</confirm-delete>
		</portal>
	</div>
</template>

<script>
	import {formatDistance, parseISO} from 'date-fns';
	import UpdateProductPricingModal from '../../components/common/UpdateProductPricingModal.vue'
	import { XIcon } from 'vue-feather-icons'
	export default {
		name: 'JobForecastProcessing',
		data () {
			return {
				isReticulation: this.$route.params.type == 'reticulation',
				showProducts: false,
				showTransport: false,
				forecast: {},
				order:{},
				companies:{},
				suppliers:{},
				loading: true,
				errors: [],
				shortcode:'',
				forecast_code:'',
				type:'',
				showUpdatePricing: null,
				productCategoriesToLoopThrough: [3, 4,1,2,5,6,8,9,10,7],
				categories: {
					reticulation: 'Reticulation',
					reticulation_general: 'Reticulation General',
					first_fix: 'First Fix',
					wire: 'Wire',
					final_fix: 'Final Fix',
					common: 'Common',
					carport: 'Carports',
					tools: 'Tools and Consumables',
					specialareas: 'Special Areas',
				},
				transport_costs: [],
				visibleInfo: [],
				productForecasts: {},
				// sectionName: {
				// 	carport: 'Phase',
				// 	common: 'Block',
				// 	final_fix: 'Unit',
				// 	final_fix_gen: 'Phase',
				// 	first_fix: 'Block',
				// 	reticulation: 'Area',
				// 	reticulation_general: 'Phase',
				// 	special_area: 'Area',
				// 	tools: 'Job',
				// 	wire: 'Block',
				// },
				// displayProducts: {},
				// sectionNames: {},
				showDelete: false
			}
		},
		computed: {
			orderDoesNotEquateForecastedQauntity(){
				return this.$_(this.order).reduce((result, products, section) => {
					this.$_(products).forEach((product, productId) => {
						if(this.$_(product.order).sumBy(order => Number(order['qty'])) != product.ordrqty){
							(result[section] || (result[section] = [])).push(productId);
						}						
					});
					return result;
				},{});
			},
			uniqueSuppliersInOrder(){
				var result = [], section;
				for (section in this.order) {
					if (this.order.hasOwnProperty(section)) {
						for (var productId in this.order[section]) {
							if (this.order[section].hasOwnProperty(productId)) {
								for (var property in this.order[section][productId]) {
									if (this.order[section][productId].hasOwnProperty(property) && property == 'order' ) {
										if(this.order[section][productId][property].length){
											this.order[section][productId][property].forEach(split => {
												let chktype = typeof split.supplier_id;
												if(split.supplier_id && chktype === 'number')
													result.push(split.supplier_id);
											});
										}
									}
								}
							}
						}
					}
				}
				return result.filter((value, index, self) => {
					return self.indexOf(value) === index;
				});
			},
			jobName: function(){
				return this.$store.getters.jobName || "Job Name";
			},
			role: function(){
				return this.$store.getters['auth/role'];
			},
			hasError: function(){
				let filtered = this.errors.filter(function (el) {
					return el != null;
				});
				return filtered.length;
			},
		},
		components: {
			UpdateProductPricingModal,
			XIcon
		},
		methods: {
			showInfo: function(key){
				let index = this.visibleInfo.findIndex(item => item == key)
				if(index == -1){
					this.visibleInfo.push(key);
					return;
				}
				this.visibleInfo.splice(index, 1);
				return;
			},
			pad: function(n, width, z){
				z = z || '0';
				n = n + '';
				return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
			},
			categoryByKey: function(key){
				return this.$store.getters.getProductCategoryNameById(key);
			},
			categoryKeyByIndex: function(key){
				if(key == 6){
					return 'final_fix_gen';
				}
				return this.$store.getters.getProductCategoryKeyByIndex(key);
			},
			orderProductsByCategory(catId){
				var result = {}, key;
				for (key in this.order) {
					if (this.order.hasOwnProperty(key) && this.order[key].category_id == catId) {
						result[key] = this.order[key];
					}
				}
				return result;
			},
			getSuppliersByCategory(catId){
				var result = {}, key, key1;
				for (key in this.suppliers) {
					if (this.suppliers.hasOwnProperty(key)) {
						for (key1 in this.suppliers[key].categories)
						{
							if(this.suppliers[key].categories[key1].id == catId)
							{
								result[key] = this.suppliers[key];
							}
						}
						
					}
				}
				return result;
			},
			getSupplierById(supplier_id){
				let result =  this.suppliers.filter(supplier => {
					return supplier.id == supplier_id;
				});
				return result[0];
			},
			daysFrom: function(dateString){
				if(dateString!=null)
				{
					return formatDistance(parseISO(dateString, "yyyy-MM-dd'T'HH:mm:ssX", new Date()), new Date(), { addSuffix: true });
				}
			},
			calculatePrice: function(qty,price){
				return Number((qty*(price*100))/100)
			},
			orderIncludesWarehouse(order) {
				let result = order.find(ord => {
					let id = ord.supplier_id + "";
					return id.includes('W');
				})
				return result;
			},
			updateForecast(details) {
				let value = this.$refs[`forecast_qty_${details.related_type}-${details.related_type_id}`][0].value;
				this.$http.post(`/forecast_products/update`, {
						product_id: details.product_id,
						category_id: details.category_id,
						related_type_id: details.related_type_id,
						related_type: details.related_type,
						qty: value,
					})
					.then(response => {
						// this.$store.commit('order/emptyStore');	
						let success = {
							title: 'Success',
							message: response.data.message,
							type: 'success'
						}
						this.$store.commit('setStatus', success)		
						this.initData()
					})
					.catch(err => {
						let error = {
							title: 'Error',
							message: response.data.message || 'Please contact Roark, page is forecast order processing',
							type: 'error'
						}
						this.$store.commit('setStatus', error);
					})
			},
			deleteForecast(details) {
				this.showDelete = {
					type: 'forecast',
					details: details,
				}
			},
			deleteObject(Obj) {
				switch(Obj.type){
					case 'forecast':
						this.$http.delete(`/forecast_products/delete`, {
							data: {
								product_id: Obj.details.product_id,
								category_id: Obj.details.category_id,
								related_type_id: Obj.details.related_type_id,
								related_type: Obj.details.related_type,								
							}
						})
							.then(response => {
								// this.$store.commit('order/emptyStore');	
								let success = {
									title: 'Success',
									message: response.data.msg,
									type: 'success'
								}
								this.$store.commit('setStatus', success)		
								this.initData()
							})
							.catch(err => {
								let error = {
									title: 'Server Error',
									message: 'Please contact Roark, page is forecast order processing',
									type: 'error'
								}
								this.$store.commit('setStatus', error);
							})
					break;
				}
				this.showDelete = false;
			},
			splitProduct: function(section, index){
				let prodOrder = { ...this.order[section][index].order[this.order[section][index].order.length - 1]};
				let newQty = Math.floor(prodOrder.qty / 2);
				let even = prodOrder.qty % 2 == 0;
				let pack_qty = this.getPackQty(newQty,this.order[section][index].pack_size);
				// this.order[section][index].order[this.order[section][index].order.length - 1].pack_qty = pack_qty.total;
				// this.order[section][index].order[this.order[section][index].order.length - 1].pack_rem = pack_qty.rem;
				
				// this.order[section][index].order[this.order[section][index].order.length - 1].qty = newQty;
				if(!even){
					newQty = newQty + 1;
				}
				prodOrder.qty = newQty;

				pack_qty = this.getPackQty(newQty,this.order[section][index].pack_size);
				prodOrder.pack_qty = pack_qty.total;
				prodOrder.pack_rem = pack_qty.rem;

				this.$set(this.order[section][index].order,this.order[section][index].order.length,prodOrder);
			},
			checkQty: function(cat, index, product ,split){
				if(String(split.supplier_id).includes('W')){
					if(split.qty > product.warehouse_product_count){
						split.qty = product.warehouse_product_count;
					}
				}
				let vals = []
				for (var i = this.order[cat][index].order.length - 1; i >= 0; i--) {
					vals.push(this.order[cat][index].order[i].qty);
				}
				if((vals.reduce((a, b) => Number(a) + Number(b), 0)) > Number(product['max'])){
					this.$set(this.errors, index, true);
				}else{
					//this.errors.splice(index, 1);
					this.$delete(this.errors, index);
				}
			},
			checkPrice: function(index, event){
				if(event.target.value === ''){
					this.$set(this.errors, index, undefined);
					return;
				}
				let price = Number(event.target.value);
				if(isNaN(price) || price === 0){
					this.$set(this.errors, index, true);
				}else{
					this.$set(this.errors, index, undefined);
				}
			},
			setTransportCost: function(supplier_id, event)
			{
				let index = this.transport_costs.findIndex(value => { return value.supplier_id === supplier_id });
				if(index != -1)
				{
					this.transport_costs[index].cost = Number(event.target.value);
				}
				else {
					this.transport_costs.push({
						'supplier_id': supplier_id,
						'cost': Number(event.target.value)
					});
				}
			},
			updateOrder: function(){
				// var order = this.$store.getters['order/getOrder']
				// var placed_by = this.$store.getters['auth/userid']
				let order = this.$_.cloneDeep(this.order);
				this.errors = [];
				for(var section in order){
					for (var productKey in order[section]) {
						if (order[section].hasOwnProperty(productKey)) {
							let totQty = 0;
							for (var i = order[section][productKey].order.length - 1; i >= 0; i--) {
								
								let supplier = Number(order[section][productKey].order[i].supplier_id);
								let qty = Number(order[section][productKey].order[i].qty);
								let price = Number(order[section][productKey].order[i].price);
								if(supplier && (qty == 0 || qty == NaN || price == 0 || price == NaN)){
									this.$set(this.errors, productKey, true);
								}else{
									totQty += qty;
									order[section][productKey].order[i].price = Math.round(price * 100);
								}
							}
							// if(totQty != Number(order[productKey].max)){
							// 	this.$set(this.errors, productKey, true);
							// }
						}
					}
				}

				if(this.errors.length){
					let success = {
						title: 'Error',
						message: 'Please check suppliers, quantities and pricing',
						type: 'error'
					}
					this.$store.commit('setStatus', success)
					return;
				}
				
				let postData = {
					'products':order,
					'user_id':this.$store.getters['auth/userid'],
					'transport_costs':this.transport_costs
				};
				this.$http.post(`/jobs/${this.$route.params.id}/forecast/process`, postData)
					.then(response => {
						// this.$store.commit('order/emptyStore');	
						let success = {
							title: 'Action Successful',
							message: response.data.message,
							type: 'success'
						}
						this.$store.commit('setStatus', success)		
						// this.reload()
						// this.$emit('reload')
						this.$router.push(`/forecasts/${this.forecast.region.id}/orders`);
					})
					.catch(err => {
						let error = {
							title: 'Server Error',
							message: 'Please contact Roark, page is forecast order processing',
							type: 'error'
						}
						this.$store.commit('setStatus', error);
					})
			},
			changeSupplierPrice: function(section, index, orderIndex){
				let select = this.$refs[`supplier-${section}-${index}-${orderIndex}`];
				console.log(select);
				let value = select[0].value.split("-");
				let prodOrder = { ...this.order[section][index]};
				console.log(value);
				
				if(value[0]=='W'){
					console.log(prodOrder);
					//then call another method to modify order and use wharehouse
					let newPrice = prodOrder.warehouse_product_price;
					
					prodOrder.order[orderIndex].price = newPrice ? (newPrice) / 100 : null;
					prodOrder.order[orderIndex].price_id = prodOrder.warehouse_product_price_id;
					prodOrder.order[orderIndex].price_date = null;

					if(prodOrder.warehouse_product_count < prodOrder.ordrqty){
						prodOrder.order[orderIndex].disabled = true;
						prodOrder.order[orderIndex].qty = prodOrder.warehouse_product_count;
						let rem = prodOrder.ordrqty - prodOrder.warehouse_product_count;
						let newSplit = this.$_.cloneDeep(prodOrder.order[orderIndex]);
						let pack_qty = this.getPackQty(rem,prodOrder.pack_size);
						newSplit.qty = rem;
						delete newSplit.disabled;
						newSplit.supplier_id = 0;
						newSplit.price = null;
						newSplit.price_date = null;
						newSplit.pack_qty = pack_qty.total;
						newSplit.pack_rem = pack_qty.rem;
						prodOrder.order.push(newSplit);
					}else{
						prodOrder.order[orderIndex].qty = prodOrder.ordrqty;
					}
					this.$set(this.errors, index, undefined);
					this.$set(this.order[section], index, prodOrder);
				}
				else 
				{
					delete prodOrder.order[orderIndex].disabled;
					
					let product = this.$_.filter(this.forecast.products[section], (prod) => {

						return prod.id == prodOrder.id;
					});
					product = product[0];

					let newPrice = product.pricing[prodOrder.order[orderIndex].supplier_id] ? product.pricing[prodOrder.order[orderIndex].supplier_id].price : null;
					let newPriceDate = product.pricing[prodOrder.order[orderIndex].supplier_id] ? product.pricing[prodOrder.order[orderIndex].supplier_id].date : null;
					prodOrder.order[orderIndex].price = newPrice ? (newPrice) / 100 : null;
					prodOrder.order[orderIndex].price_date = newPriceDate ? newPriceDate : null;
					this.$set(this.order[section], index, prodOrder);
					let supplier = Number(prodOrder.order[orderIndex].supplier_id);
					if(supplier == NaN || supplier == 0){
						this.$set(this.errors, index, true);
					}else{
						this.$set(this.errors, index, undefined);
					}
					
				}
			},
			removeSupplier: function(section, index, orderIndex){
				let prodOrder = Object.values({ ...this.order[section][index].order});
				prodOrder[orderIndex]['price'] = null;
				prodOrder[orderIndex]['price_date'] = null;
				prodOrder[orderIndex]['price_id'] = null;
				prodOrder[orderIndex]['supplier_id'] = 0;
				this.$set(this.order[section][index],'order',prodOrder);
			},
			getPackQty: function(qty, pack_size){
				let total = Math.ceil(qty / pack_size);
				let rem = pack_size-qty;
				if(qty > pack_size){
					total = Math.floor(qty / pack_size);
					rem = qty % pack_size;
					if(rem > 0){
						total++;
						rem = pack_size - rem;
					}
				}
				return {
					total: total,
					rem: rem
				};
			},
			initData: function(){
				let url = `jobs/${this.$route.params.id}/forecasts/`;
				if(this.isReticulation){
					url += `area/${this.$route.params.areaid}`;
				}

				this.$http.get(url)
				.then(response => {
					this.forecast = response.data.details;
					this.forecast.products = response.data.products;
					this.forecast_code = this.forecast.reference_id
					
					Object.keys(this.forecast.products).forEach((section) => {
						if(this.forecast.products[section].length){
							this.forecast.products[section].forEach((product) => {
								let totalQty = product.forecasted_qty;
								let pack_qty = this.getPackQty(totalQty,product.pack_size);							
								let orders = [];

								if(product['forecasts'].length){
									product['forecasts'].forEach(fc => {
										fc['orders'].forEach(fcorder => {
											let pack_qty = this.getPackQty(fcorder['ordered_qty'],product.pack_size);							
											orders.push({
												company_id: fcorder['company_id'],
												supplier_id: fcorder['type'] == 'warehouse' ? 'W-'+fcorder['supplier_id'] : fcorder['supplier_id'],
												price: fcorder['price']['price'],
												price_id: fcorder['price']['id'],
												price_date: fcorder['price']['created_at'],
												total_qty: totalQty,
												qty: fcorder['ordered_qty'],
												pack_qty: pack_qty.total,
												pack_rem: pack_qty.rem,
											});										
										});
									});
									if(! orders.length){
										orders.push({
											company_id: 1,
											supplier_id: 0,
											price: null,
											price_id: null,
											price_date: null,
											total_qty: totalQty,
											qty: totalQty,
											pack_qty: pack_qty.total,
											pack_rem: pack_qty.rem,
										});									
									}
									orders = this.$_(orders).groupBy('supplier_id').reduceRight((result, group) => {
										let formattedPrice = group[0].price/100;
										result.push({
											company_id: group[0].company_id,
											supplier_id: group[0].supplier_id,
											price: formattedPrice == 0 ? null : formattedPrice,
											price_date: group[0].price_date,
											price_id: group[0].price_id,
											total_qty: group[0].total_qty,
											qty: this.$_(group).sumBy(item => Number(item['qty'])),
											pack_qty: group[0].pack_qty,
											pack_rem: group[0].pack_rem,
										});
										return result;
									}, []);
								}
								let newProduct = {
									id: product.id,
									pack_size: product.pack_size,
									priorities: [],
									category_id: product['forecasts'][0].category_id,
									name: product.name,
									max: totalQty,
									ordrqty: totalQty,
									status: 'ordered',
									warehouse_name:product.warehouse_name,
									warehouse_id:'W-'+product.warehouse_id,
									warehouse_product_count:product.warehouse_product_count,
									warehouse_product_price_id:product.warehouse_product_price_id,
									warehouse_product_price:product.warehouse_product_price,
									forecasts: product.forecasts,									
									order: orders
								};
								if(newProduct.forecasts.length == 1 && newProduct.category_id == 3){
									newProduct.feeds = newProduct.forecasts[0].feeds;
									newProduct.expected_delivery_datetime = newProduct.forecasts[0].expected_delivery_datetime;
								}
								if(! this.order[section]){
									this.$set(this.order, section, {});
								}
								this.$set(this.order[section], newProduct.id, {});
								this.$set(this.order[section], newProduct.id, newProduct);						
							});
	                    }
					});
					this.productForecasts = this.$_(this.order).reduce((result,products, section) => {
						
						(result[section] || (result[section] = {}));
						this.$_(products).forEach((product, productId) => {
							(result[section][productId] || (result[section][productId] = this.$_(product.forecasts).groupBy('related_type_id').map((forecasts, related_type_id) => {
								return {
									product_id: productId,
									category_id: forecasts[0].category_id,
									related_type_id: Number(related_type_id),
									related_type: forecasts[0].related_type,
									name: forecasts[0].section+' '+forecasts[0].section_name,
									qty: this.$_(forecasts).sumBy('forecasted_qty')
								};
							}).value()));
						});
						return result
					},{});
					//this.$store.commit('setJobName', this.forecast.job_name)
					this.loading = false;
				})
				.catch(err => {
					this.error = err
				})
			}
		},
		created () {
			this.$store.commit('setJobName', null)
			this.$http.get(`companies`)
				.then(response => {
					this.companies = response.data
				})
				.catch(err => {
					this.error = err
				});
			this.$http.get(`suppliers`)
				.then(response => {
					this.suppliers = response.data
				})
				.catch(err => {
					this.error = err
				});
			
			var regionid = this.$route.params.regionid
			if(regionid == 1)
			{
				this.shortcode = 'GAU';
			}
			if(regionid == 2)
			{
				this.shortcode = 'KZN';
			}
			if(regionid == 3)
			{
				this.shortcode = 'CTW';
			}
			this.type = this.$route.params.type
			
			this.initData();
		}
	}
</script>